const backendDomin = process.env.REACT_APP_API_URL;

//  const backendDomin = process.env.REACT_APP_LOCALHOST_URI;

const SummaryApi = {
  userRegister: {
    url: `${backendDomin}/api/register`,
    method: "post",
  },
  signIn: {
    url: `${backendDomin}/api/login`,
    method: "post",
  },
  createYatra: {
    url: `${backendDomin}/api/create-yatra`,
    method: "post",
  },
  deleteYatra: {
    url: `${backendDomin}/api/yatra-delete`,
    method: "delete",
  },
  updateYatra: {
    url: `${backendDomin}/api/update-yatra`,
    method: "put",
  },
  updateYatraPhoto: {
    url: `${backendDomin}/api/update-yatra-poster`,
    method: "put",
  },
  addYatraDescription: {
    url: `${backendDomin}/api/addDescription`,
    method: "post",
  },
  updateYatraRules: {
    url: `${backendDomin}/api/updateYatraRules`,
    method: "post",
  },
  getAllYatra: {
    url: `${backendDomin}/api/all-yatras`,
    method: "get",
  },
  yatraById: {
    url: `${backendDomin}/api/yatra`,
    method: "get",
  },
  createVarkari: {
    url: `${backendDomin}/api/create-varkari`,
    method: "post",
  },
  getAllVarkaris: {
    url: `${backendDomin}/api/allVarkari`,
    method: "get",
  },
  getVarkarisByYatraId: {
    url: `${backendDomin}/api/varkari-by-id`,
    method: "get",
  },
  updateVarkari: {
    url: `${backendDomin}/api/update-varkari`,
    method: "put",
  },
  addPayment: {
    url: `${backendDomin}/api/add-payment`,
    method: "post",
  },
  updateBookingStatus: {
    url: `${backendDomin}/api/updateBookingStatus`,
    method: "put",
  },
  updatePaidAmount: {
    url: `${backendDomin}/api/update-paid-amount`,
    method: "put",
  },
  saveFinancialSummary: {
    url: `${backendDomin}/api/financial-summary`,
    method: "post",
  },
  removeYatraFromVarkari: {
    url: `${backendDomin}/api/remove-varkari`,
    method: "post",
  },
  addYatraToVarkaris: {
    url: `${backendDomin}/api/add-yatra-to-varkaris`,
    method: "post",
  },
  addYatraToMultipleVarkaris: {
    url: `${backendDomin}/api/add-yatra-to-multivarkaris`,
    method: "post",
  },

  createTrain: {
    url: `${backendDomin}/api/createtrain`,
    method: "post",
  },
  getTrainByYatra: {
    url: `${backendDomin}/api/trains`,
    method: "post",
  },
  updateTrain: {
    url: `${backendDomin}/api/updatetrain`,
    method: "post",
  },
  deleteTrain: {
    url: `${backendDomin}/api/deletetrain`,
    method: "post",
  },

  createTrainGroup: {
    url: `${backendDomin}/api/creategroup`,
    method: "post",
  },
  getTraingroup: {
    url: `${backendDomin}/api/getgroups`,
    method: "post",
  },
  deleteTrainGroup: {
    url: `${backendDomin}/api/deletegroup`,
    method: "post",
  },
   updateTrainGroup: {
    url: `${backendDomin}/api/updategroup`,
    method: "post",
  },
   removeMember: {
    url: `${backendDomin}/api/removemember`,
    method: "post",
  },
};

export default SummaryApi;
